/**
 * Global Configuration
 * Production default: `https://api.xynth.com`.
 * For local dev, set `NEXT_PUBLIC_API_BASE_URL` (e.g. `https://localhost:8080` when using `local_dev.sh`).
 */
const _envApi = process.env.NEXT_PUBLIC_API_BASE_URL?.trim();
export const API_BASE_URL =
  _envApi && _envApi.length > 0 ? _envApi : "https://api.xynth.com";
if (typeof window !== "undefined") {
  console.log(`[XYNTH] API_BASE_URL = ${API_BASE_URL}`);
}

const _envSupportTawkPropertyId =
  process.env.NEXT_PUBLIC_SUPPORT_TAWK_PROPERTY_ID?.trim();
const _envSupportTawkWidgetId =
  process.env.NEXT_PUBLIC_SUPPORT_TAWK_WIDGET_ID?.trim();
const _envSupportCalendlyUrl =
  process.env.NEXT_PUBLIC_SUPPORT_CALENDLY_URL?.trim();

export const SUPPORT_TAWK_PROPERTY_ID =
  _envSupportTawkPropertyId && _envSupportTawkPropertyId.length > 0
    ? _envSupportTawkPropertyId
    : "69d6e28aa5ae3e1c3b561820";

export const SUPPORT_TAWK_WIDGET_ID =
  _envSupportTawkWidgetId && _envSupportTawkWidgetId.length > 0
    ? _envSupportTawkWidgetId
    : "1jlnm9rf1";

export const SUPPORT_TAWK_DIRECT_URL = `https://tawk.to/chat/${SUPPORT_TAWK_PROPERTY_ID}/${SUPPORT_TAWK_WIDGET_ID}`;

export const SUPPORT_CALENDLY_URL =
  _envSupportCalendlyUrl && _envSupportCalendlyUrl.length > 0
    ? _envSupportCalendlyUrl
    : "https://calendly.com/syedhashim2015/30min";

const _envSupportGoogleMeetUrl =
  process.env.NEXT_PUBLIC_SUPPORT_GOOGLE_MEET_URL?.trim();
export const SUPPORT_GOOGLE_MEET_URL =
  _envSupportGoogleMeetUrl && _envSupportGoogleMeetUrl.length > 0
    ? _envSupportGoogleMeetUrl
    : "https://meet.google.com/fdx-xwpw-uox";

const _envOnboardingCalendlyUrl =
  process.env.NEXT_PUBLIC_ONBOARDING_CALENDLY_URL?.trim();
export const ONBOARDING_CALENDLY_URL =
  _envOnboardingCalendlyUrl && _envOnboardingCalendlyUrl.length > 0
    ? _envOnboardingCalendlyUrl
    : "https://calendly.com/hashims-xynth/onboarding-meeting";

/**
 * Breaking Changes Cutoff Datedoes
 * Sessions created before this date cannot be continued due to Xynth 2.0 breaking changes
 * Format: ISO 8601 (YYYY-MM-DDTHH:mm:ss.sssZ)
 */
export const BREAKING_CHANGE_CUTOFF_DATE = new Date(
  "2026-03-03T00:00:00.000-05:00"
); // Mar 3, 2026 at 12:00 AM EST

// Export as default for convenience
export default {
  API_BASE_URL,
  SUPPORT_TAWK_PROPERTY_ID,
  SUPPORT_TAWK_WIDGET_ID,
  SUPPORT_TAWK_DIRECT_URL,
  SUPPORT_CALENDLY_URL,
  SUPPORT_GOOGLE_MEET_URL,
  ONBOARDING_CALENDLY_URL,
  BREAKING_CHANGE_CUTOFF_DATE,
};
